module.exports = __webpack_public_path__ + "img/3.349e425d.png";